import { apiFetch } from "../../lib/api";
import { getSupabase } from "../../lib/supabase";

export type IssueStatus = "open" | "acknowledged" | "resolved" | "dismissed";

export type Issue = {
  id: string;
  station_id: string;
  charger_id: string | null;
  reporter_id: string | null;
  description: string;
  status: IssueStatus;
  created_at: string;
  resolved_at: string | null;
  resolved_by: string | null;
};

export type IssueCreateInput = {
  station_id: string;
  charger_id?: string | null;
  description: string;
  cf_turnstile_response?: string | null;
};

export async function createIssue(input: IssueCreateInput): Promise<Issue> {
  return apiFetch<Issue>("/issues", { method: "POST", body: input });
}

export async function listMine(): Promise<Issue[]> {
  return apiFetch<Issue[]>("/issues/mine");
}

export async function listForStation(stationId: string): Promise<Issue[]> {
  const sb = getSupabase();
  const { data, error } = await sb
    .from("station_issues")
    .select("*")
    .eq("station_id", stationId)
    .eq("flagged", false)
    .in("status", ["open", "acknowledged"])
    .order("created_at", { ascending: false });
  if (error) throw new Error(`listForStation failed: ${error.message}`);
  return (data ?? []) as Issue[];
}

export async function countOpenForStation(stationId: string): Promise<number> {
  const sb = getSupabase();
  const { count, error } = await sb
    .from("station_issues")
    .select("*", { count: "exact", head: true })
    .eq("station_id", stationId)
    .eq("flagged", false)
    .in("status", ["open", "acknowledged"]);
  if (error) throw new Error(`countOpenForStation failed: ${error.message}`);
  return count ?? 0;
}
